import { AxiosWidget, handleError, handleResponse } from '@services/SettingAxios';
import { TypePromiseDataShmByShop, TypePromiseRecordShm } from './TypePromise';
import config from '@app/config';

class ServiceWidget {
  private safeMode: boolean = config.safeModeWidget === 'true';
  async getRecordShm(shops: number[], isWithYellowSlots?: boolean): Promise<TypePromiseRecordShm[]> {
    const url = isWithYellowSlots ? '/api/widget-service/shopList?withYellowSlots=true' : '/api/widget-service/shopList';

    return this.safeMode ? null : AxiosWidget.post(url, { shops }).then(handleResponse).catch(handleError);
  }

  async getDataShmByShop(shopId: number): Promise<TypePromiseDataShmByShop> {
    return this.safeMode
      ? null
      : AxiosWidget.get(`/api/widget-service/shopInfo?shop=${shopId}`)
          .then(handleResponse)
          .catch(error => handleError(error, null));
  }
}

const serviceWidgetInstance = new ServiceWidget();

export default serviceWidgetInstance;
